const styles = {
    content: {
      textAlign: 'center',
      padding: 10
    }
  };
export default styles;


// WEBPACK FOOTER //
// ./src/components/noResults/styles/NoResultsBoxStyles.js